export default "__VITE_ASSET__uBbRd055__"